import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarCoverageV1Response } from './get-grammar-coverage-v1-response';
import { getGrammarCoverageV1ResponseSchema } from './get-grammar-coverage-v1-response';

export async function getGrammarCoverageV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarCoverageV1Response>> {
  return getRequest<IGetGrammarCoverageV1Response>({
    path: '/sys/grammar/v1/coverage',
    schema: getGrammarCoverageV1ResponseSchema,
    options,
  });
}
